import styled from 'styled-components';
import { customBreakPoint } from '~/styles/break-points';

export const StyledContent = styled.div`
	margin-top: 1rem;
	display: flex;
	flex-direction: column;
	gap: 2rem;

	.filters--container {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;

		${customBreakPoint(
			500,
			`
			flex-direction: row;
			align-items: center;
			gap: 3rem;
		`,
		)}
	}

	.tile-container {
		display: flex;
		flex-direction: column;
		gap: 2rem;

		${customBreakPoint(
			500,
			`
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
			row-gap: 2rem;
			`,
		)}
		${customBreakPoint(
			1150,
			`
				grid-template-columns: repeat(3, 1fr);
			`,
		)}
		 .not-found {
			max-width: 480px;
			display: flex;
			flex-direction: column;
			text-align: left;
			grid-column: span 3;

			ul {
				list-style: disc;
				margin-left: 1rem;
			}
		}

		.card-skeleton {
			width: 277px;
			height: 560px;
		}
		@media (max-width: 768px) {
			.card-skeleton {
				width: 100%;
			}
		}

		& > button {
			max-width: max-content;
			align-self: center;
		}
	}
`;
